import { configureStore } from "@reduxjs/toolkit";
import collectionBarReducer from "./ducks/collection-bar";
import cookieConsentReducer from "./ducks/cookie-consent";
import cookieSettingsReducer from "./ducks/cookie-settings";
import customerCaptureOverlayReducer from "./ducks/customer-capture-overlay";
import feedSwitchTabOverlayReducer from "./ducks/feed-switch-tab-overlay";
import feedFiltersReducer from "./ducks/feed-filters";
import feedSidebarReducer from "./ducks/feed-sidebar";
import signupOverlayReducer from "./ducks/signup-overlay";
import appHeaderSearchReducer from "./ducks/app-header-search";
import appHeaderCartReducer from "./ducks/app-header-cart";
import shippingAndReturnsOverlayReducer from "./ducks/shipping-and-returns-overlay";
import feedShowMoreReducer from "./ducks/feed-show-more";
import feedSeoContentReducer from "./ducks/feed-seo-content";
import mainNavigationReducer from "./ducks/main-navigation";
import appDownloadBannerReducer from "./ducks/app-download-banner";
import followDesignerBannerReducer from "./ducks/follow-designer-banner";

const store = configureStore({
    reducer: {
        collectionBarReducer,
        cookieConsentReducer,
        cookieSettingsReducer,
        customerCaptureOverlayReducer,
        feedSwitchTabOverlayReducer,
        feedFiltersReducer,
        feedSidebarReducer,
        signupOverlayReducer,
        appHeaderSearchReducer,
        appHeaderCartReducer,
        shippingAndReturnsOverlayReducer,
        feedShowMoreReducer,
        feedSeoContentReducer,
        mainNavigationReducer,
        followDesignerBannerReducer,
        appDownloadBannerReducer,
    },
});

export type ReduxStoreState = ReturnType<typeof store["getState"]>;

export default store;
